const namespace = "UI";
export const SET_OPEN_MODAL = `${namespace}/SET_OPEN_MODAL`;
export const SHOW_TOAST = `${namespace}/SHOW_TOAST`;
export const HIDE_TOAST = `${namespace}/HIDE_TOAST`;
